import SelectedArticles from './selectedArticles'

const selectedArticles = new SelectedArticles()
selectedArticles.init()
